// import ScrollToTop from './components/Partials/ScrollToTop';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import GlobalContextProvider from './components/Contexts/GlobalContext';

import Navbar from './components/Partials/Navbar/Navbar';
import Footer from './components/Partials/Footer/Footer';
import Home from './components/Pages/Home';
import PresidentMessage from './components/Pages/PresidentMessage';
import BoardOfDirectors from './components/Pages/BoardOfDirectors';
import ContactUs from './components/Pages/ContactUs';
import CelebratingLuminites from './components/Pages/CelebratingLuminites';


function App() {
  
  
  return (

    <Router>
    
    {/* <ScrollToTop/> */}
    
      <div className="body">

        <GlobalContextProvider>
        
            <Navbar/>
              <div className="wrap">

                <Routes>
                  <Route path='/' exact element={<Home/>} />
                  <Route path='/presidentMessage' element={<PresidentMessage/>} />
                  <Route path='/boardOfDirectors' element={<BoardOfDirectors/>} />
                  <Route path='/contactUs' element={<ContactUs/>} />
                  <Route path='/celebratingLuminites' element={<CelebratingLuminites/>} />
                  <Route path='/celebratingLuminites/:year' element={<CelebratingLuminites/>} />
                </Routes>
                
              </div>
            <Footer/>

        </GlobalContextProvider>
      
      </div>

  </Router>

  );
}

export default App;


//////////////////////////////////////////////////////////////
//////////////////////[ NOTE ]////////////////////////////////
//////////////////////////////////////////////////////////////
//we area using React.memo() while exporting some components which have no props or if they have props then these never change
//if in future we integrate api and in some components we will have continuous change in props then remove React.memo() 
//other wise it will effect performance 